module.exports = __webpack_public_path__ + "static/media/logo20.8a0ffed2.png";